


















import { Component, Vue } from 'vue-property-decorator'
import { VTable, TableHander } from '@/components/table'
import { QueryDayActivityLeaderboard } from '@/api'

@Component({
  components: {
    VTable,
  },
})
export default class ActivityDayLeaderboardList extends Vue {
  private queryParam: any = {
    startRow: 1,
    limit: 10,
    rewardDate: '',
  }
  private tableTotal = 0
  private tableData: any[] = []
  private tableCurrntPage = 1

  private tableHander: Array<TableHander> = [
    { title: '名次', param: 'rank', minWidth: 72 },
    { title: '用户ID', param: 'userId', minWidth: 110 },
    { title: '昵称', param: 'nickName', minWidth: 140 },
    { title: '手机号', param: 'mobilePhone', minWidth: 130 },
    { title: '当日活跃度', param: 'activityQty', minWidth: 120 },
  ]

  public activated() {
    this.loadData()
  }

  public created() {
    this.queryParam.rewardDate = this.todayYmd()
    this.loadData()
  }

  private todayYmd() {
    const d = new Date()
    const y = d.getFullYear()
    const m = ('0' + (d.getMonth() + 1)).slice(-2)
    const day = ('0' + d.getDate()).slice(-2)
    return `${y}-${m}-${day}`
  }

  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryDayActivityLeaderboard(param)
    this.tableTotal = result.total
    this.tableData = result.list || []
  }

  private getRequestParam() {
    const param: any = { ...this.queryParam }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 10)
    if (!param.rewardDate) {
      param.rewardDate = this.todayYmd()
    }
    return param
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }

  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
